export const TECHNICIAN_VIDEOS_INITIATE_ADD_VIDEO = 'TECHNICIAN_VIDEOS_INITIATE_ADD_VIDEO';
export const TECHNICIAN_VIDEOS_ADD_VIDEO_START = 'TECHNICIAN_VIDEOS_ADD_VIDEO_START';
export const TECHNICIAN_VIDEOS_ADD_VIDEO_SUCCESS = 'TECHNICIAN_VIDEOS_ADD_VIDEO_SUCCESS';
export const TECHNICIAN_VIDEOS_ADD_VIDEO_FAIL = 'TECHNICIAN_VIDEOS_ADD_VIDEO_FAIL';
export const TECHNICIAN_VIDEOS_ADD_VIDEO_RESET = 'TECHNICIAN_VIDEOS_ADD_VIDEO_RESET';